import { Tag } from "../../../models";
import {
    CREATE_TAG
} from "../../constants"

export const createTag = (data) => ({
    type: CREATE_TAG,
    payload: new Tag(data)
})